import { u as a } from "../styled-components.browser.esm-3eb04950.js";
import { Tabs as r } from "antd";
const o = a(r)`
    height: 100%;

    .ant-tabs-content-holder {
        flex-grow: 1;
    }

    .ant-tabs-content {
        padding: 20px;
        height: 100%;
        background-color: white;
        border-radius: 0 var(--big-border-radius) var(--big-border-radius) var(--big-border-radius);
    }

    .ant-tabs-tab {
        padding: 20px;
        font-size: 20px;
        border: none !important;
        background: var(--light-grey-2) !important;

        &-active {
            background: #fff !important;
        }
    }

    .ant-tabs-nav {
        margin: 0;
    }

    .ant-tabs-nav-list {
        padding: 0;
    }
`;
export {
  o as BironTabs
};
//# sourceMappingURL=BironTabs.js.map
